import { ButtonHTMLAttributes, FC } from 'react';

import { IconName, Size } from '@purpur/library/icon';
import { IconChevronRight } from '@purpur/library/icon/chevron-right';

import { RectButtonText, StyledButton } from './RectShapedButton.styles';
import { RoundFilledIcon, RoundFilledIconVariant } from './RoundFilledIcon';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;
type Props = { icon?: IconName | string; iconSize?: Size; iconVariant?: RoundFilledIconVariant } & ButtonProps;

export const RectShapedButton: FC<Props> = ({
    children,
    icon,
    iconSize,
    iconVariant,
    type = 'button',
    ...inheritedProps
}) => (
    <StyledButton type={type} {...inheritedProps}>
        {!!icon && <RoundFilledIcon icon={icon} size={iconSize} variant={iconVariant} />}
        {typeof children === 'string' ? <RectButtonText>{children}</RectButtonText> : children}
        <IconChevronRight />
    </StyledButton>
);
